module.exports = __webpack_public_path__ + "static/media/china-high-speed-line-cover.ab60ce6b.jpg";